import { css } from 'styled-components';
import { legacyShadows } from '../../../theme/shadows.js';
import typography from '../../../theme/typography.js';
export const Primary = {
    colors: {
        main: '#00B2E3',
        mainDark: '#0087C1',
        mainLight: '#CBF6FF',
        positive120: '#056B42',
        positive100: '#1BAB5D',
        positive70: '#1ADB81',
        positive30: '#74E6AD',
        positive10: '#E8FCF1',
        critical120: '#BB2532',
        critical100: '#E8313A',
        critical70: '#F64C56',
        critical30: '#FF8993',
        critical10: '#FFD1DA',
        warning120: '#A57412',
        warning100: '#FBB104',
        warning70: '#FCC736',
        warning30: '#FDDC72',
        warning10: '#FFF2CC',
        link120: '#104D93',
        link100: '#1268ED',
        link70: '#4C8AF6',
        link30: '#B1CFFB',
        link10: '#E7EEFE',
        //
        black_1: '#2E2F33',
        black_2: '#2E2F33',
        black_3: '#2E2F33',
        //
        blackDark_1: '#111113',
        //
        grey00_1: '#FFFFFF',
        grey00_2: '#FFFFFF',
        grey00_5: '#FFFFFF',
        grey00_6: '#FFFFFF',
        grey00_7: '#FFFFFF',
        //
        grey01_1: '#F7F7F8',
        grey01_2: '#F7F7F8',
        grey01_3: '#F7F7F8',
        //
        grey05_1: '#F2F2F3',
        grey05_2: '#F2F2F3',
        grey05_3: '#F2F2F3',
        grey05_4: '#F2F2F3',
        //
        grey10_1: '#EAEBEB',
        grey10_2: '#EAEBEB',
        grey10_5: '#EAEBEB',
        //
        grey30_1: '#D7D8DA',
        grey30_2: '#D7D8DA',
        //
        grey70_1: '#A1A2A8',
        grey70_3: '#A1A2A8',
        //
        grey100_1: '#6D7176',
        grey100_2: '#6D7176',
        // Secondary
        purple120: '#7A05B1',
        purple100: '#A31AE3',
        purple70: '#C876EF',
        purple30: '#DBA3F4',
        purple10: '#FCDDFD',
        //
        purpleBlue120: '#4E2AD9',
        purpleBlue100: '#7551FF',
        purpleBlue70: '#9E84FF',
        purpleBlue30: '#C6B8FF',
        purpleBlue10: '#EBE5FF',
        //
        teal120: '#007474',
        teal100: '#039C9C',
        teal70: '#04CDCD',
        teal30: '#89E8E8',
        teal10: '#D7FEFE',
        //
        pink120: '#CC3683',
        pink100: '#EF5DA8',
        pink70: '#F38BC1',
        pink30: '#F8B9DA',
        pink10: '#FDE8F2',
        //
        lightBlue120: '#0282CA',
        lightBlue100: '#39B8FF',
        lightBlue70: '#6BCAFF',
        lightBlue30: '#9EDCFF',
        lightBlue10: '#E5F6FF',
        //
        coral120: '#E24639',
        coral100: '#FF6F63',
        coral70: '#FF9A92',
        coral30: '#FFD4D0',
        coral10: '#FFF1EF',
        //
        green120: '#36AC4A',
        green100: '#74D585',
        green70: '#8BEF9D',
        green30: '#CEF9D5',
        green10: '#EFFDF1',
        //
        yellow120: '#DAA71A',
        yellow100: '#F4C954',
        yellow70: '#F7D987',
        yellow30: '#FBEFCC',
        yellow10: '#FEFAEE',
    },
    shadows: {
        ...legacyShadows,
        focus: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.mainLight};
    `,
        error: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.critical10};
    `,
        warning: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.warning10};
    `,
        success: css `
      box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.positive10};
    `,
        large: css `
      box-shadow:
        0 10px 30px rgb(40 50 64 / 12%),
        0 0 3px rgb(0 0 0 / 10%);
    `,
        medium: css `
      box-shadow:
        0 0 3px rgb(0 0 0 / 8%),
        0 8px 24px rgb(0 0 0 / 4%);
    `,
        small: css `
      box-shadow:
        0 4px 10px rgb(0 0 0 / 2%),
        0 1px 2px rgb(0 0 0 / 2%);
    `,
    },
    typography,
    borders: {
        radiusMedium: 8,
    },
    themeId: 'primary',
};
